module.exports = __webpack_public_path__ + "static/media/Jermaime_Product Listings.639407bb.docx";